import { PropTypes } from 'prop-types';
// Removing imports for MVP0 - Story #417
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { DefaultAssetDetails } from '@ge/models/constants';
import { globalColors } from '@ge/tokens/colors';

const TurbineContent = styled.div`
  display: flex;
  font-family: GE Inspira;
  line-height: 1.5;
  flex-direction: column;
  grid-template-columns: repeat(4, 1fr);
  gap: 4px 8px;
  padding: 10px 50px 7px 25px;
  margin-bottom: 15px;
  min-height: 50px;
  box-shadow: 0px 2px 5px rgb(0 0 0 / 10%), 0px 0px 6px rgb(0 0 0 / 10%);
`;
const TurbineText = styled.div`
  display: flex;
  color: ${globalColors.grey12};
  justify-content: space-between;
  font-family: 'Museo Sans';
  font-size: 12px;
  font-style: normal;
`;

// do we need to round a particular way here?
const formatReadingValue = (val) => {
  if (val === 0) return null;
  const formatted = Number(val).toFixed(1);
  return Number.isNaN(formatted) ? null : formatted;
};

const AssetRealtimeInfo = ({ asset }) => {
  const { t, ready } = useTranslation(['entity-details'], {
    useSuspense: false,
  });

  const { readings } = asset.metrics || {};
  const { signals = [] } = readings || {};

  const getDetails = useCallback(
    (detailId) => {
      const val = signals.length ? signals.find((x) => x.id === detailId) : null;
      if (!val) return null;
      const { id, labelId, desc, uom, value } = val || {};
      return (
        <TurbineText key={id}>
          {t(`readings_entity.${labelId}`, desc)}{' '}
          <span>{formatReadingValue(value) ? `${formatReadingValue(value)} ${uom}` : '—'}</span>
        </TurbineText>
      );
    },
    [signals, t],
  );

  if (!ready) {
    return null;
  }

  return (
    <>
      {Object.keys(DefaultAssetDetails).map((ele) => (
        <TurbineContent key={ele}>
          <h3>{t(`mobile_card.${ele}`, ele)}</h3>
          {DefaultAssetDetails[ele].map((s, id) => getDetails(s, id))}
        </TurbineContent>
      ))}
    </>
  );
};

AssetRealtimeInfo.propTypes = {
  asset: PropTypes.shape({
    metrics: PropTypes.object,
  }).isRequired,
};

export default AssetRealtimeInfo;
